import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {RequestMethod, RestService} from '../../../../shared/services/rest.service';
import {ResponseSnackbarService} from '../../../../shared/services/response-snackbar.service';
import {Actions, ApiEndpoints} from '../../../../shared/constants/ApiEndpoints';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {GeneralConstant} from '../../../../shared/constants/GeneralConstant';
import {Subject} from 'rxjs';
import {SpinnerButtonListener} from '../spinner-button/spinner-button.component';
import {PageableResponse} from '../../../../shared/models/datasource/pageable-response';
import {FacilityProgram} from '../../../../shared/models/accr/FacilityProgram';
import {TooltipService} from '../../../../shared/services/tooltip.service';
import {MessageInfo} from '../../../../shared/enums/error-messages/MessageInfo';


@Component({
  selector: 'app-multi-reassign-specialist',
  templateUrl: './multi-reassign-specialist.component.html',
  styleUrls: ['./multi-reassign-specialist.component.scss']
})
export class MultiReassignSpecialistComponent implements OnInit {
  formGroup: FormGroup;
  facilityId: number;
  dateFormat = GeneralConstant.DATE_FORMAT;
  isSpecialist = true;
  minDateToAssign: any;
  dateSelected = new Date();
  protected onDestroy = new Subject<void>();
  charChange: any;
  facilities: any[];
  list: number[];
  assignee: any;
  name: string;
  private tooltipService: TooltipService;
  private listFacilities: any;
  formattedText = '';
  private selectedSpecialistClinicalReviewer: any;
  specialists: any[];
  constructor(
    private restService: RestService,
    private responseSnackBar: ResponseSnackbarService,
    private dialogRef: MatDialogRef<MultiReassignSpecialistComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.tooltipService = new TooltipService(this.formGroup);
    this.assignee = data.assignee;
    this.name = data.name;
    this.minDateToAssign = new Date();
  }

  ngOnInit() {
    this.getFalicities();
  }

  initForm() {
    this.formGroup = new FormGroup({
      facilities: new FormControl(this.facilities?.map(it => it.id), Validators.required),
      specialist: new FormControl(this.specialists?.map(it => it.id), Validators.required),
      closeAssignments: new FormControl(false),
      enddate: new FormControl(this.dateSelected, Validators.required),
      startdate: new FormControl(this.dateSelected, Validators.required),
      textField: new FormControl('', Validators.required)
    });
    this.formGroup.controls.textField.valueChanges.subscribe(value => {
    });
    this.updateFacilties(null);
  }

  updateFacilties(value) {
    this.getSpecialists(Date.now());
  }

  onTextareaValueChanged(event: Event): void {
    const input = (event.target as HTMLTextAreaElement).value;
    const lines = input.split("\n");
    for (var i = 0; i < lines.length; i++) {
      lines[i] = lines[i].replace(/[^0-9]+/g, "");
      if (lines[i].length > 10) {
        lines[i] = lines[i].substring(0, 10);
      }
    }
    this.formGroup.controls.textField.setValue(lines.join('\n'));
  }


  /**
   * Assign specialist
   */
  assignSpecialist(event: SpinnerButtonListener) {

    if (this.formGroup.value.textField || this.formGroup.value.textField !== ''){
      this.formGroup.get('facilities').setValidators(null);
      this.formGroup.get('specialist').setValidators(null);
      this.formGroup.get('facilities').updateValueAndValidity();
      this.formGroup.get('specialist').updateValueAndValidity();

      this.listFacilities =  this.formGroup.value.textField?.split('\n').map((i) => Number(i));

    }
    if (this.formGroup.value.facilities || this.formGroup.value.textField !== undefined){
      this.formGroup.get('textField').setValidators(null);
      this.formGroup.get('specialist').setValidators(null);
      this.formGroup.get('textField').updateValueAndValidity();
      this.formGroup.get('specialist').updateValueAndValidity();

      this.listFacilities =  this.listFacilities ? this.listFacilities.concat(this.formGroup.value.facilities) : this.formGroup.value.facilities;

    }


    if (!this.formGroup.valid) {
      event.onComplete();
      return;
    }

    const dto: any = {};
    dto.assigneeId = this.assignee.id;
    dto.startDate = this.formGroup.value.startdate;
    dto.endDate = this.formGroup.value.enddate;
    dto.facilities = this.listFacilities ? this.listFacilities.filter(element => element !== null) : [];
    dto.closeAssignments = this.formGroup.value.closeAssignments;
    dto.specialistId =  this.selectedSpecialistClinicalReviewer ? this.selectedSpecialistClinicalReviewer.id : null;

    this.restService.request<any>(RequestMethod.PUT, ApiEndpoints.ACCR.APPLICATION,
      Actions.ACCR_APPLICATION.ASSIGN_SPECIALIST + '/facilities', {
        body: dto
      }).subscribe(
      response => {
        event.onComplete();
        if (response.success) {
          this.dialogRef.close({});
          this.responseSnackBar.onResponseMessage('Successfully updated facility', GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS);
        } else {
          this.responseSnackBar.onResponse(response);
        }
      }
    );
  }

  getFalicities() {
    this.restService.request<PageableResponse<FacilityProgram>>(RequestMethod.GET, ApiEndpoints.FACILITY_INFO.NATIONAL_ACCOUNT, Actions.BASE_ACTIONS.READ + '/facilities').subscribe(
      response => {
        if (response.success && response.data) {
          this.initForm();
          this.facilities = [];
          this.facilities = response.data.items;
        }
      });
  }
  getSpecialists(date: any) {
    this.restService.request<any>(RequestMethod.GET,  ApiEndpoints.ACCR.SPECIALIST_DETAILS,
      Actions.BASE_ACTIONS.READ + '/all').subscribe(
      response => {
        if (response.success) {
          this.specialists = response.data;
        } else {
          this.responseSnackBar.onResponse(response);
        }
      }
    );
  }
  specialistChange(event) {
    this.selectedSpecialistClinicalReviewer = event.value;

    if (event.value != null) {
      this.formGroup.get('textField').clearValidators();
      this.formGroup.get('textField').disable();
      this.formGroup.get('facilities').clearValidators();
      this.formGroup.get('facilities').disable();
   //   this.formGroup.get('textField').setValue('');
   //   this.formGroup.get('facilities').setValue([]);
    }
    else {
      this.formGroup.get('textField').setValidators(Validators.required);
      this.formGroup.get('textField').enable();
      this.formGroup.get('facilities').setValidators(Validators.required);
      this.formGroup.get('facilities').enable();

    }
    this.formGroup.get('textField').updateValueAndValidity();
    this.formGroup.get('facilities').updateValueAndValidity();

  }

  facilitiesChange($event: any) {
    this.formGroup.get('specialist').setValidators(null);
    this.formGroup.get('specialist').disable();
    this.formGroup.get('specialist').updateValueAndValidity();
    this.selectedSpecialistClinicalReviewer = null;
  }
}
